import styled from 'styled-components';

export const InspectionTypeList = styled.div`
  max-height: 14rem;
  overflow-y: auto;

  .ant-checkbox-group {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }
`;
